import {
  UCCMPEvent,
  UCConsentEvent,
  UCInitializedEvent,
  UCV3ExtendedWindow,
} from '@/types/usercentrics/v3';
import { UcV3Event } from '@/types/usercentrics/v3/enums';

export const LOCAL_UC_DATA_KEY = 'ucData';

export const isUCAvailable = () => !!(window as unknown as UCV3ExtendedWindow).__ucCmp;

export const getUC = () => {
  const uc = (window as unknown as UCV3ExtendedWindow).__ucCmp;

  if (!uc) {
    throw new Error('Missing UC CMP');
  }

  return uc;
};

export const isUCCMPEvent = (event: Event): event is UCCMPEvent => {
  return event.type === UcV3Event.CMPEvent;
};

export const isUCInitializedEvent = (event: Event): event is UCInitializedEvent => {
  return event.type === UcV3Event.Initialized;
};

export const isUCConsentsChangeEvent = (event: Event): event is UCConsentEvent => {
  return event.type === UcV3Event.Consent;
};

export const isNotOnInitialPageLoadUCConsentsChangeEvent = (event: UCConsentEvent) => {
  return event.detail.consent.updatedBy !== 'onInitialPageLoad';
};

export const getLocalUCTrackingData = () => {
  const rawData = localStorage.getItem(LOCAL_UC_DATA_KEY);

  if (rawData) {
    return JSON.parse(rawData);
  }
};

export const isTCFEnabled = () => {
  return import.meta.env.VITE_ENABLE_TCF === 'true';
};
